import { SVGProps } from "react";

export const MinusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 6H11.25" stroke="CurrentColor" stroke-width="1.2" stroke-linecap="round"/>
</svg>
);
